<template>
	<div class="page" v-loading="loading">
		<el-breadcrumb>
			<el-breadcrumb-item>企业代理管理</el-breadcrumb-item>
			<el-breadcrumb-item>基本信息</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form style="width: 50%; margin-top: 30px; margin-left: 15px;">
			<el-form-item>
				<span class="label">企业名称：</span>
				<el-input v-model="infoList.name" style="width: 200px;" size="mini" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<span class="label">企业性质：</span>
				<el-select v-model="infoList.nature" placeholder="请选择" value-key="label" size="mini">
					<el-option :value="1" label="国家行政企业"></el-option>
					<el-option :value="2" label="公私合作企业"></el-option>
					<el-option :value="3" label="中外合资企业"></el-option>
					<el-option :value="4" label="社会组织机构"></el-option>
					<el-option :value="5" label="国际组织机构"></el-option>
					<el-option :value="6" label="外资企业"></el-option>
					<el-option :value="7" label="私营企业"></el-option>
					<el-option :value="8" label="集体企业"></el-option>
					<el-option :value="9" label="国防军事企业"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<span class="label">企业等级：</span>
				<el-select v-model="infoList.grade" placeholder="请选择" value-key="label" size="mini">
					<el-option :value="1" label="VIP代理商"></el-option>
					<el-option :value="2" label="铂金代理商"></el-option>
					<el-option :value="6" label="钻石代理商"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<span class="label">联系人：</span>
				<el-input v-model="infoList.contacts" style="width: 200px;" size="mini" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<span class="label">联系方式：</span>
				<el-input v-model="infoList.contactInformation" style="width: 200px;" size="mini" clearable></el-input>
				<!-- <el-button type="infor" size="mini" style="margin-left: 10px;">+ 新增</el-button> -->
			</el-form-item>
			<el-form-item>
				<span class="label">邮箱：</span>
				<el-input type="email" v-model="infoList.email" style="width: 200px;" size="mini" clearable></el-input>
			</el-form-item>
			<el-form-item prop="info.businessDay">
				<span class="label">营业日：</span>
				<el-checkbox-group v-model="businessDay" class="checkGroup">
					<el-checkbox label="星期一"></el-checkbox>
					<el-checkbox label="星期二"></el-checkbox>
					<el-checkbox label="星期三"></el-checkbox>
					<el-checkbox label="星期四"></el-checkbox>
					<el-checkbox label="星期五"></el-checkbox>
					<el-checkbox label="星期六"></el-checkbox>
					<el-checkbox label="星期日"></el-checkbox>
				</el-checkbox-group>
				<el-time-picker is-range v-model="infoList.businessTime" range-separator="—" placeholder="选择时间范围"
					size="mini" value-format="HH:mm">
				</el-time-picker>
			</el-form-item>
			<!-- 	<el-form-item label="企业位置:">
				<el-select v-model="province" placeholder="请选择" value-key="label" size="mini" filterable>
					<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id"
						clearable @change="selectProvince">
					</el-option>
				</el-select>
				<el-select v-model="city" placeholder="请选择" value-key="label" size="mini" filterable>
					<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.name" clearable>
					</el-option>
				</el-select>
			</el-form-item> -->
			<el-form-item>
				<span class="label">详细地址：</span>
				<el-input v-model="infoList.address" style="width: 300px;" size="mini" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<span class="label">特色项目：</span>
				<el-tag type="info" effect="plain" closable :key="tag" v-for="tag in project" @close="handleClose(tag)">
					{{ tag }}
				</el-tag>
				<el-input v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
					@keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm" class="input-new-tag">
				</el-input>
				<el-button v-else class="button-new-tag" size="small" @click="showInput">+</el-button>
			</el-form-item>
			<el-form-item>
				<span class="label">企业二维码：</span>
				<el-upload :auto-upload="false" :on-change="onChangeImg" action="#" list-type="picture-card" :limit="1"
					:show-file-list="false" class="avatar-uploader">
					<img v-if="infoList.QRcode" :src="infoList.QRcode" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon" style="color:#007CFF"></i>
				</el-upload>

			</el-form-item>
			<el-form-item>
				<span class="label" style=" vertical-align: top;">企业简介：</span>
				<el-input v-model="infoList.introduction" type="textarea" size="mini" clearable style="width: 650px;"
					autosize>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="success" size="mini" style="float: right; background: #0CC428;" @click="onSave">保存
				</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'Information',
		data() {
			return {
				loading: false,
				name: '',
				nature: '',
				grade: '',
				contacts: '',
				contactInformation: '',
				email: '',
				businessDay: [],
				businessTime: '',
				provinceList: [],
				cityList: [],
				areaList: [],
				province: '',
				city: '',
				address: '',
				project: [],
				inputValue: '',
				inputVisible: '',
				QRcode: '',
				introduction: '',
				// fileList: [],
				info: [],
				infoList: {},
			}
		},
		methods: {
			getData() {
				this.loading = true
				this.$util.get('agent/getAgentInfo')
					.then(res => {
						console.log(res)
						this.loading = false
						if (res[0].info && res[0].info.length > 0) {
							this.info = res[0].info
							this.infoList = this.info[0]
							this.businessDay = this.infoList.businessDay
							this.project = this.infoList.project
						} else {
							this.info = []
							this.businessDay = []
							this.project = []
						}
					})
			},
			getCity() {
				this.$util.get('areas', {
						level: 1,
					})
					.then(res => {
						// console.log(res.data)
						this.provinceList = res.data
					})
			},
			selectProvince(val) {
				this.$util.get('areas', {
						parent_id: val
					})
					.then(res => {
						this.cityList = res.data
						console.log(res.data)
					})
			},
			handleChange(value) {
				console.log(value)
			},
			selectNature(val) {
				this.nature = val
			},
			selectGrade(val) {
				this.grade = val
			},
			clickDay(val) {
				console.log(val)
			},
			handleClose(tag) {
				this.project.splice(this.project.indexOf(tag), 1);
			},
			showInput() {
				this.inputVisible = true;
				this.$nextTick(() => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},
			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.project.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			onSave() {
				this.info = [{
					name: this.infoList.name,
					nature: this.infoList.nature,
					grade: this.infoList.grade,
					contacts: this.infoList.contacts,
					contactInformation: this.infoList.contactInformation,
					email: this.infoList.email,
					businessDay: this.businessDay,
					businessTime: this.infoList.businessTime,
					// location: this.location,
					address: this.infoList.address,
					project: this.project,
					QRcode: this.infoList.QRcode,
					introduction: this.infoList.introduction,
				}]
				this.$util.post('agent/setAgentInfo', {
						info: this.info
					})
					.then(res => {
						console.log(res)
						this.$message('已保存')
						this.getData()
					})
			},
			onChangeImg(file) {
				let fetchForm = new FormData();
				fetchForm.append("file", file.raw);
				this.$util.post("/upload", fetchForm)
					.then((res) => {
						this.infoList.QRcode = res.data
					})
			},
		},
		mounted() {
			this.getCity()
			this.getData()
		}
	}
</script>

<style scoped>
	.el-date-editor--timerange.el-input__inner {
		width: 200px;
	}

	.el-date-editor {
		margin-left: 105px;
	}

	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}

	.avatar-uploader {
		display: inline-block;
		margin-left: 10px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 148px;
		height: 148px;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 148px;
		height: 148px;
		line-height: 148px;
		text-align: center;
	}

	.avatar {
		width: 148px;
		height: 148px;
		display: block;
		/* margin-top: 5px; */
		/* margin-left: 110px; */
		margin-left: -1px;
		margin-top: -1px;
	}

	.label {
		text-align: right;
		width: 100px;
		display: inline-block;
	}

	.checkGroup {
		display: inline-block;
		margin-left: 5px;
	}
</style>
